import classnames from 'classnames'
import React, { FC, useMemo } from 'react'

import { useI18nPreviewContext } from '@src/quince-site-common/src/contexts/i18n-preview-context/i18n-preview-context'
import productHelper from '@src/quince-site-common/src/helpers/productHelper'
import { PRODUCT_TAGS_IMAGE_LIMIT, TAG_POSITION } from '@src/quince-site-common/src/utils/constants'
import { getDisplayKey } from '@src/utils/i18n.utils'

import { ProductCardTag } from '../../product-card.types'

import { getTagPriority } from './product-tags.helper'
import styles from './product-tags.module.scss'
import { ReadyToShip } from './ready-to-ship'

interface ProductTagsProps {
  applicableTags?: ProductCardTag[]
  readyToShip?: boolean
  className?: string
  position?: TAG_POSITION
}

export const ProductTags: FC<ProductTagsProps> = ({
  applicableTags = [],
  readyToShip = false,
  className,
  position = TAG_POSITION.BOTTOM,
}) => {
  const isI18nPreviewEnabled = useI18nPreviewContext()
  // Sort tags according to priority
  const sortedTags = useMemo(() => {
    return [...applicableTags].sort((a, b) => getTagPriority(a.value) - getTagPriority(b.value))
  }, [applicableTags])

  return (
    <ul className={classnames(styles.tagList, styles[`tagList__${position}`], className)}>
      {sortedTags.slice(0, PRODUCT_TAGS_IMAGE_LIMIT).map(tag => {
        const tagText = getDisplayKey(tag, 'displayName', tag.value, isI18nPreviewEnabled)
        return (
          <li className={classnames(styles.tag, tag.tagType && styles[`tag__${tag.tagType}`])} key={tag.value}>
            {productHelper.getTagValueWithFirstLetterUpperCase(tagText)}
          </li>
        )
      })}
      <ReadyToShip shouldShowReadyToShipTag={readyToShip} />
    </ul>
  )
}
